import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, ArrowUp, MessageCircle } from "lucide-react";
import { BRAND } from "@/data/catalog";

export default function FloatingActions() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col items-end gap-3">
      <AnimatePresence>
        {show && (
          <motion.button
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.6 }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            data-testid="back-to-top"
            aria-label="Back to top"
            className="grid place-items-center h-11 w-11 rounded-full glass border border-border text-foreground hover:bg-navy hover:text-white transition-colors"
          >
            <ArrowUp size={18} />
          </motion.button>
        )}
      </AnimatePresence>
      <a
        href={`tel:${BRAND.phone.replace(/\s/g, "")}`}
        data-testid="sticky-call"
        aria-label="Call us"
        className="grid place-items-center h-12 w-12 rounded-full bg-royal text-white shadow-lg hover:scale-110 transition-transform"
      >
        <Phone size={20} />
      </a>
      <a
        href={`https://wa.me/${BRAND.whatsapp}?text=Hi%20ElitzPacks%2C%20I'd%20like%20a%20quote`}
        target="_blank"
        rel="noreferrer"
        data-testid="sticky-whatsapp"
        aria-label="WhatsApp"
        className="grid place-items-center h-14 w-14 rounded-full bg-emerald text-white shadow-xl hover:scale-110 transition-transform"
      >
        <MessageCircle size={24} />
      </a>
    </div>
  );
}
